module.exports = __webpack_public_path__ + "static/media/RP-85.b8122842.pdf";